/*
 * mo-lead-kit.js (2026-10-16)
 *
 * 1. Call links ([data-mo-call]): show the shopper's showroom (the "Your store" choice that
 *    assets/custom.js writes to <html data-mo-selected-showroom> and announces with
 *    `mo:showroom-change`). The five tel: anchors are moved, never re-created, so the numbers
 *    CallRail swap.js already replaced for a Google Ads visitor stay replaced.
 * 2. "Text me" forms ([data-mo-textme]): bed and price, delivery quote, store directions.
 *    One phone field (plus a ZIP for delivery) and the chat's SMS consent text. Posts to the
 *    shop-chat-agent backend (POST /text-me) with the chat attribution bundle (click ids),
 *    then hands the Google tag the SHA-256 phone (same normalize and hash as the chat's
 *    GoogleUserData). Raw contact data goes only to the backend, never to dataLayer.
 *
 * Inline UI only; nothing here is fixed-position.
 */
(function () {
  'use strict';
  if (window.MOLeadKit) { window.MOLeadKit.scan(); return; }

  var ENDPOINT = 'https://mo-shop-chat-agent-production.up.railway.app/text-me';
  var GOOGLE_TAG = 'AW-310848106';
  // Same words as the chat lead form and quiz gate (SMS_CONSENT_TEXT on the backend).
  var CONSENT_TEXT = "I agree to receive recurring automated marketing & cart-reminder texts from Mattress Overstock at the number above. Consent isn't a condition of purchase. Msg & data rates may apply. Reply STOP to opt out, HELP for help.";
  var STORES = {
    'nicholasville-road': 'Lexington',
    'richmond': 'Richmond',
    'georgetown': 'Georgetown',
    'london': 'London',
    'somerset': 'Somerset'
  };
  var TITLES = {
    product: 'Text me this bed and today\u2019s price',
    delivery: 'Text me a delivery quote',
    directions: 'Text me the address and directions'
  };
  var DONE = {
    product: 'Sent. Check your texts for the bed and today\u2019s price.',
    delivery: 'Got it. We texted you a confirmation, and our team will text your quote during store hours.',
    directions: 'Sent. Check your texts for the address and directions.'
  };

  function push(event, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var data = { event: event };
      for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) data[k] = params[k];
      window.dataLayer.push(data);
    } catch (e) { /* non-fatal */ }
  }

  /* ---------- 1. call links ---------- */

  function selectedStore() {
    var key = document.documentElement.getAttribute('data-mo-selected-showroom');
    return key && STORES[key] ? key : 'nicholasville-road';
  }

  function applyCall(block, key) {
    var primary = block.querySelector('[data-mo-call-primary]');
    var others = block.querySelector('[data-mo-call-others]');
    var name = block.querySelector('[data-mo-call-name]');
    if (!primary || !others) return;
    var target = block.querySelector('a[data-mo-call-store="' + key + '"]');
    if (!target) return;
    if (target.parentNode !== primary) {
      Array.prototype.slice.call(primary.querySelectorAll('a[data-mo-call-store]')).forEach(function (a) { others.appendChild(a); });
      primary.appendChild(target);
      // Keep the "other showrooms" list in a stable north-to-south order.
      Object.keys(STORES).forEach(function (k) {
        var a = others.querySelector('a[data-mo-call-store="' + k + '"]');
        if (a) others.appendChild(a);
      });
    }
    if (name) name.textContent = STORES[key];
    block.setAttribute('data-mo-call-ready', key);
  }

  function applyAllCalls() {
    var key = selectedStore();
    document.querySelectorAll('[data-mo-call]').forEach(function (block) { applyCall(block, key); });
  }

  /* ---------- 2. text-me forms ---------- */

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function attribution() {
    var out = {};
    try {
      var stored = JSON.parse(localStorage.getItem('shopAiAttribution') || '{}');
      if (stored && typeof stored === 'object') {
        ['gclid', 'gbraid', 'wbraid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'landing_url', 'click_url', 'referrer']
          .forEach(function (k) { if (typeof stored[k] === 'string' && stored[k]) out[k] = stored[k]; });
      }
    } catch (e) { /* storage blocked */ }
    try {
      // A click id on this page view wins if the stored record has none (chat Attribution rule).
      var p = new URLSearchParams(window.location.search);
      var hasStored = out.gclid || out.gbraid || out.wbraid || out.fbclid;
      if (!hasStored) ['gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(function (k) { var v = p.get(k); if (v) out[k] = v.slice(0, 256); });
    } catch (e) { /* no URL params */ }
    try {
      var ga = readCookie('_ga');
      var m = ga && ga.match(/GA\d+\.\d+\.(.+)$/);
      if (m) out.ga_client_id = m[1].slice(0, 64);
      var fbp = readCookie('_fbp'); if (fbp) out.fbp = fbp.slice(0, 128);
      var fbc = readCookie('_fbc'); if (fbc) out.fbc = fbc.slice(0, 256);
    } catch (e) { /* cookies blocked */ }
    return out;
  }

  function funnelId() {
    try { return sessionStorage.getItem('shopAiFunnelId'); } catch (e) { return null; }
  }

  // Same normalization and hash as ShopAIChat.GoogleUserData in assets/mo-ai-chat.js.
  function normPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return null;
  }

  function sha256(text) {
    var bytes = new TextEncoder().encode(text);
    return window.crypto.subtle.digest('SHA-256', bytes).then(function (digest) {
      return Array.prototype.map.call(new Uint8Array(digest), function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    });
  }

  function sendGoogleUserData(phone, kind) {
    try {
      if (typeof window.gtag !== 'function' || !window.crypto || !window.crypto.subtle) return;
      var p = normPhone(phone);
      if (!p) return;
      sha256(p).then(function (hash) {
        window.gtag('set', 'user_data', { sha256_phone_number: hash });
        window.gtag('event', 'form_submit', { send_to: GOOGLE_TAG, form_id: 'mo-textme-' + kind });
      }).catch(function () { /* non-fatal */ });
    } catch (e) { /* non-fatal */ }
  }

  function currentVariantId(block) {
    var scope = block.closest('.product-information, .product, product-info, section') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    var v = input && input.value ? String(input.value) : '';
    if (/^\d{1,20}$/.test(v)) return v;
    var fallback = block.getAttribute('data-variant-id') || '';
    return /^\d{1,20}$/.test(fallback) ? fallback : null;
  }

  function setOpen(block, kind) {
    var form = block.querySelector('[data-mo-textme-form]');
    if (!form) return;
    var same = !form.hidden && form.getAttribute('data-kind') === kind;
    block.querySelectorAll('[data-mo-textme-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', String(!same && b.getAttribute('data-mo-textme-open') === kind));
    });
    if (same) { form.hidden = true; return; }
    var oldDone = block.querySelector('.mo-lk-done');
    if (oldDone) oldDone.remove();
    form.setAttribute('data-kind', kind);
    form.querySelector('[data-mo-textme-title]').textContent = TITLES[kind] || 'Text me this';
    var zip = form.querySelector('[data-mo-textme-zip]');
    if (zip) zip.hidden = kind !== 'delivery';
    var status = form.querySelector('[data-mo-textme-status]');
    if (status) status.textContent = '';
    form.hidden = false;
    var phone = form.querySelector('input[name="phone"]');
    if (phone) { try { phone.focus({ preventScroll: false }); } catch (e) { phone.focus(); } }
    push('text_me_opened', { text_me_kind: kind });
  }

  function submit(block, form) {
    var kind = form.getAttribute('data-kind');
    var phone = form.querySelector('input[name="phone"]').value.trim();
    var zipInput = form.querySelector('input[name="zip"]');
    var zip = zipInput ? zipInput.value.trim() : '';
    var consent = form.querySelector('input[name="consent"]').checked;
    var status = form.querySelector('[data-mo-textme-status]');
    var button = form.querySelector('[data-mo-textme-submit]');
    var consentLabel = form.querySelector('.mo-lk-form__consent');
    if (consentLabel) consentLabel.classList.remove('is-attention');
    if (!normPhone(phone)) { status.textContent = 'Enter a 10-digit US mobile number.'; return; }
    if (kind === 'delivery' && !/^\d{5}$/.test(zip)) { status.textContent = 'Enter your 5-digit ZIP code.'; return; }
    if (!consent) {
      status.textContent = 'Check the consent box so we can text you.';
      if (consentLabel) consentLabel.classList.add('is-attention');
      return;
    }
    var payload = {
      kind: kind,
      phone: phone,
      consent_sms: true,
      consent_text: CONSENT_TEXT,
      funnel_id: funnelId(),
      attribution: attribution()
    };
    if (kind === 'product' || kind === 'delivery') {
      payload.handle = block.getAttribute('data-handle');
      payload.variant_id = currentVariantId(block);
    }
    if (kind === 'delivery') payload.zip = zip;
    if (kind === 'directions') payload.store = block.getAttribute('data-store');

    button.disabled = true;
    var label = button.textContent;
    button.textContent = 'Sending...';
    status.textContent = '';
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok && data && data.ok, data: data || {} }; });
    }).then(function (r) {
      if (!r.ok) {
        button.disabled = false;
        button.textContent = label;
        status.textContent = (r.data && r.data.error) || 'Something went wrong. Please try again.';
        push('text_me_failed', { text_me_kind: kind });
        return;
      }
      sendGoogleUserData(phone, kind);
      push('text_me_submitted', { text_me_kind: kind });
      var done = document.createElement('p');
      done.className = 'mo-lk-done';
      done.setAttribute('role', 'status');
      done.textContent = DONE[kind] || 'Sent.';
      form.hidden = true;
      form.reset();
      button.disabled = false;
      button.textContent = label;
      var old = block.querySelector('.mo-lk-done');
      if (old) old.remove();
      form.parentNode.insertBefore(done, form.nextSibling);
      block.querySelectorAll('[data-mo-textme-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }).catch(function () {
      button.disabled = false;
      button.textContent = label;
      status.textContent = 'Network error. Please try again.';
    });
  }

  function bindTextMe(block) {
    if (block.getAttribute('data-mo-textme-bound') === '1') return;
    block.setAttribute('data-mo-textme-bound', '1');
    var form = block.querySelector('[data-mo-textme-form]');
    if (!form) return;
    var consentText = form.querySelector('[data-mo-textme-consent]');
    if (consentText) consentText.textContent = CONSENT_TEXT;
    block.querySelectorAll('[data-mo-textme-open]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(block, b.getAttribute('data-mo-textme-open')); });
    });
    var cancel = form.querySelector('[data-mo-textme-cancel]');
    if (cancel) cancel.addEventListener('click', function () {
      form.hidden = true;
      block.querySelectorAll('[data-mo-textme-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); submit(block, form); });
  }

  function scan() {
    applyAllCalls();
    document.querySelectorAll('[data-mo-textme]').forEach(bindTextMe);
  }

  window.MOLeadKit = Object.freeze({ scan: scan, selectedStore: selectedStore });
  document.addEventListener('mo:showroom-change', applyAllCalls);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // custom.js applies the stored or automatic store after load; pick it up when it lands.
  setTimeout(applyAllCalls, 1200);
  setTimeout(applyAllCalls, 3500);
})();
